<video width="100%" height="auto" autoplay loop [muted]="'muted'">
  <source src="assets/front/vid/login.mp4" type="video/mp4" />
</video>
<div class="flex flex-wrap">
  <div class="lg:col-12 p-0 relative">
    <!-- <img class="left-img lg:col-12 p-0" [src]="images.leftBg" alt="" /> -->
    <div class="company-logo-container absolute top-0 w-full">
      <div class="flex flex-column">
        <div class="tagline flex justify-content-center">
          Driving Success in Venue <br />Commerce
        </div>
        <div class="tagline-2">
          Your ultimate venue commerce solution designed to revolutionize
          <br />
          managing sporting venues and arenas
        </div>
      </div>
    </div>
  </div>
</div>
